import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQueryWithReauth';
import { getApiBaseUrl } from './api';

export const testEnvironmentApiSlice = createApi({
  reducerPath: 'testEnvironmentApi',
  baseQuery: baseQueryWithReauth(getApiBaseUrl()),
  tagTypes: ['TestEnvironment', 'TestProgress'],
  endpoints: (builder) => ({
    // Generate test environment
    generateTestEnvironment: builder.mutation({
      query: (config) => ({
        url: 'testing/generate-test-environment/',
        method: 'POST',
        body: config,
      }),
      invalidatesTags: ['TestEnvironment'],
    }),

    // Check generation progress
    getSimulationProgress: builder.query({
      query: (taskId) => `testing/simulation-progress/${taskId}/`,
      providesTags: (result, error, taskId) => [{ type: 'TestProgress', id: taskId }],
      // Poll every 5 seconds (reduced from 2s for performance)
      pollingInterval: 5000,
    }),

    // Clean up test data
    cleanupTestData: builder.mutation({
      query: (data) => ({
        url: 'testing/cleanup-test-data/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TestEnvironment'],
    }),

    // Get test environment list (if needed)
    getTestEnvironments: builder.query({
      query: () => 'testing/environments/',
      providesTags: ['TestEnvironment'],
    }),
  }),
});

export const {
  useGenerateTestEnvironmentMutation,
  useGetSimulationProgressQuery,
  useLazyGetSimulationProgressQuery,
  useCleanupTestDataMutation,
  useGetTestEnvironmentsQuery,
} = testEnvironmentApiSlice;
